import React from 'react';
import {
  FormPageInputItemSingleSelectionPulldown,
  FormPageInputItemSingleSelectionRadio,
  SingleSelectionPropertyPulldown,
  SingleSelectionPropertyRadio,
  SINGLE_SELECTION_PROPERTY_INPUT_TYPE,
} from 'shared';
import { hasErrorMessage } from '../shared';
import { SingleSelectionPulldown } from './SingleSelectionPulldown';
import { SingleSelectionRadio } from './SingleSelectionRadio';
import { SingleSelectionInputProps } from './shared';

const isError = (
  errorMessages: SingleSelectionInputProps['errorMessages'],
  displayError = false,
): boolean => !!displayError && hasErrorMessage(errorMessages);

export const SingleSelectionInput: React.FC<SingleSelectionInputProps> = (
  props,
) => {
  switch (props.property.inputFormat.inputType) {
    case SINGLE_SELECTION_PROPERTY_INPUT_TYPE.pulldown: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as SingleSelectionInputProps<
          SingleSelectionPropertyPulldown,
          FormPageInputItemSingleSelectionPulldown
        >;
      const displayError = submitted || (touched && touched.value);
      return (
        <SingleSelectionPulldown
          value={value.value}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    case SINGLE_SELECTION_PROPERTY_INPUT_TYPE.radio: {
      const {
        submitted,
        touched,
        errorMessages,
        value,
        property,
        ...baseProps
      } = props as SingleSelectionInputProps<
        SingleSelectionPropertyRadio,
        FormPageInputItemSingleSelectionRadio
      >;
      const displayError = submitted || (touched && touched.value);
      return (
        <SingleSelectionRadio
          property={property}
          value={value.value}
          subtexts={value.subtexts}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
  }
};
